import { render, staticRenderFns } from "./uploadButton.vue?vue&type=template&id=2896087c&scoped=true"
import script from "./uploadButton.vue?vue&type=script&lang=js"
export * from "./uploadButton.vue?vue&type=script&lang=js"
import style0 from "./uploadButton.vue?vue&type=style&index=0&id=2896087c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2896087c",
  null
  
)

export default component.exports